var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content",style:(_vm.mainContentViewHeight)},[_c('pm-form-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }